import { createFileRoute } from "@tanstack/react-router";
import AnxietyTreatmentPage from "@/pages/AnxietyTreatmentPage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute("/anxiety-treatment-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Anxiety Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Anxiety treatment in Coral Springs, FL. TMS, SPRAVATO, ketamine, medication management, and therapy for anxiety disorders at Neuro Wellness TMS.",
        },
        {
          property: "og:title",
          content: "Anxiety Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Anxiety treatment in Coral Springs, FL. TMS, SPRAVATO, ketamine, medication management, and therapy for anxiety disorders at Neuro Wellness TMS.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/anxiety-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/anxiety-treatment-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for Anxiety Treatment Coral Springs, FL | Neuro Wellness",
              seoDescription:
                "Discover rapid relief from anxiety with IV Ketamine therapy at Neuro Wellness TMS Centers of America in Coral Springs, FL. Safe, effective treatment for severe anxiety & panic.",
              canonical: "/anxiety-treatment-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                {
                  name: "Anxiety",
                  href: "/anxiety-treatment-coral-springs-fl",
                },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AnxietyTreatmentPage />;
}
